import { CheckoutState } from '../state';
import { createSelector } from './utils/selector';

if (typeof window !== 'undefined') {
    require('../utils/vendor/square_analytics');
}

export type Square = {
    Analytics: new (marketAccount: string, apiHost: string) => SquareAnalytics;
};

export const getHasSqAnalyticsToken = (state: CheckoutState) =>
    !!state.tokens?.sqAnalyticsToken;

export interface SquareAnalytics {
    getToken: (callback: (sqAnalyticsToken: string) => void) => void;
}

export const getSquareAnalytics = createSelector<
    SquareAnalytics,
    (squareMarketAccount: string, squareApiHost: string) => SquareAnalytics
>(
    (state: CheckoutState) => state.app.squareMarketAccount,
    (state: CheckoutState) => state.app.squareApiHost,
    (squareMarketAccount, squareApiHost) =>
        new (window as unknown as { Square: Square }).Square.Analytics(
            squareMarketAccount,
            squareApiHost,
        ),
);
